import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom';
import { fechaToText, ModalForAll, ProfileContent, returnCurrentDateTime } from '../../components'
import { ImagenesGlobal } from '../../components/global/ImagenesGlobal';
import ArrowNext from '@mui/icons-material/ArrowForwardIos';
import ArrowBack from '@mui/icons-material/ArrowBackIosNew';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import LimitText from '../../components/global/LimitText';
import CommentGlobe from '../../svg/CommentGlobe';
import SendIcon from '@mui/icons-material/Send';
import MoodIcon from '@mui/icons-material/Mood';
import Picker from '@emoji-mart/react';
import data_emoticons from '@emoji-mart/data';
import CallApi from '../../data/CallApi';
import { LoadingComments } from '../../components/skeleton/LoadingComments';
import ButtonLoader from '../../components/global/ButtonLoader';
import { toast } from 'react-toastify';

const styleButtons = {
    width: '25%',
    backgroundColor: 'rgba(255,255,255,0.3)'
};

const API_URL = process.env.REACT_APP_API_URL;
const token_local = String(localStorage.getItem("token"));

const PreviewPublication = ({
    publicationSelected = {},
    removeProduct,
    myProfile,
    myFullName = 'Cargando..',
    dbData,
    loadImageS = (() => { }),
    getUrlPost = (() => { }),
    increaseComment = (() => { })
}) => {
    const lengthImgs = (publicationSelected?.img_list ?? []).length;
    const itsUser = String(publicationSelected?.type) == 'user' ? 'f1' : 'f2';

    const [listPosition, setListPosition] = useState(0);
    const [comment, setComment] = useState("");
    const [array_comments, setArray_comments] = useState([]);
    const [isLoading, setIsLoading] = useState({
        comments: false,
        new_comment: false
    });

    function closeModal(decision = false) {
        if (decision) removeProduct(publicationSelected);
        else removeProduct({});
    }


    function handleMakeover(next) {
        setListPosition((current_position) => next ? ((current_position + 1) === lengthImgs ? 0 : current_position + 1) : ((current_position - 1) < 0 ? lengthImgs - 1 : current_position - 1));
    }

    async function getComments() {
        if (!dbData) return console.error("No fue posible cargar los datos localesf");

        setIsLoading((current_val) => ({
            ...current_val,
            comments: true
        }));

        const keyComments = 'comments_' + publicationSelected?.order;
        let companyExp = await dbData.get('expiration', keyComments);

        const currentDT = returnCurrentDateTime();
        let updateComments = false;

        if (companyExp) {
            const expirationDT = new Date(companyExp.Value);
            const newCurrentDT = new Date(currentDT);

            expirationDT.setMinutes(expirationDT.getMinutes() + 30);

            if (newCurrentDT > expirationDT) updateComments = true;
        } else updateComments = true;

        const getListCompanies = await dbData.get('comments', publicationSelected?.order ?? "nada");
        let extractedResult;

        if (updateComments || !getListCompanies || (getListCompanies && getListCompanies.Value.length == 0)) {
            await dbData.put('expiration', { id: keyComments, Value: currentDT });

            extractedResult = await CallApi({
                url: `api/publications/comments?postCode=${publicationSelected?.authCode}&form=${itsUser}`
            });

            extractedResult = (extractedResult ?? []).map((post, index) => {
                post.authCode = String(publicationSelected?.order) + index;
                return post;
            });

            await dbData.put('comments', { id: publicationSelected?.order, Value: extractedResult });
        } else {
            extractedResult = getListCompanies?.Value;
        }

        setIsLoading((current_val) => ({
            ...current_val,
            comments: false
        }));

        setArray_comments(extractedResult);
    }

    useEffect(() => {
        if ([13, 14].includes(Object.keys(publicationSelected ?? {}).length) && myFullName) {
            setListPosition(0);
            getComments();
        }
    }, [publicationSelected, myFullName]);

    const [stateEmoticons, setStateEmoticons] = useState(false);
    const positionCaret = useRef(0);

    async function addComment() {
        if(token_local.length<10) return toast.info("Debes iniciar sesión para comentar");

        setIsLoading((current_val) => ({
            ...current_val,
            new_comment: true
        }));

        const newComment = await CallApi({
            method: 'post',
            url: `api/publications/comments`,
            body: {
                'postCode': publicationSelected?.authCode,
                'text': comment,
                'form': itsUser
            }
        });

        if (!newComment || newComment?.code == 500) {
            setIsLoading((current_val) => ({
                ...current_val,
                new_comment: true
            }));

            return;
        }

        const currentListComments = [...array_comments];

        currentListComments.push({
            authCode: String(publicationSelected?.order) + currentListComments.length,
            profile: 'me',
            user: 'me',
            text: comment
        });

        increaseComment();
        setArray_comments(currentListComments);
        await dbData.put('comments', { id: publicationSelected?.order, Value: currentListComments });

        setComment("");

        setIsLoading((current_val) => ({
            ...current_val,
            new_comment: false
        }));
    }

    const listComments = !isLoading.comments ? (
        array_comments.map((item, index) => (
            <li key={item?.authCode}>
                {
                    <ProfileContent
                        profile_url={item?.profile != 'me' ? item?.profile : myProfile}
                        loadImageS={loadImageS}
                        className='shadow-lvl2'
                        style={{ height: '40px' }}
                    />
                }

                <div style={{ width: '100%' }}>
                    <LimitText
                        lineLimit={[1, 2, 2]}
                        class_container='shadow-lvl2 scroll-thin'
                        extra_code={(<Link to={`user/posts${item?.profile != 'me' ? "?authCode=" + item?.userCode : ''}`}>{
                            item?.profile != 'me' ? item?.user : myFullName
                        }</Link>)}
                        style_container={{ padding: '0px 10px 10px 10px' }}
                    >
                        {item?.text}
                    </LimitText>
                </div>
            </li>
        ))
    ) : (
        <LoadingComments />
    );

    return (
        <ModalForAll
            stateModal={Object.keys(publicationSelected ?? {}).length > 0 ? true : false}
            setStateModal={closeModal}
            className={'content-preview-post' + (lengthImgs == 0 ? ' mini-modal' : '')}
            iconSize='20px'
            iconType='back'
            iconColor='var(--color-placeholder)'
            styleButton={{
                top: '8px',
                borderRadius: '50%',
                padding: '5px',
                backgroundColor: '#EAEAEA',
                right: '99.5%',
                transform: 'translateX(100%)'
            }}
        >
            {
                stateEmoticons && (
                    <div style={{
                        position: 'absolute',
                        top: '0px',
                        left: '0px',
                        width: '100%',
                        height: '100%',
                        zIndex: 3
                    }} onClick={() => setStateEmoticons(false)}></div>
                )
            }

            <div className='cpp-1' style={{ width: lengthImgs > 0 ? '50%' : '100%' }}>
                <div style={{ overflow: 'hidden', height: '100%' }}>
                    <div className='cpp-1-head'>
                        <div className='head-publication'>
                            {
                                <ProfileContent profile_url={publicationSelected?.its_me ? myProfile : publicationSelected?.profile} loadImageS={loadImageS} className='shadow-lvl2-bottom' />
                            }

                            <div>
                                <Link to={getUrlPost(publicationSelected?.searchCode, publicationSelected?.its_me)}>
                                    <span className='color-title-user text-bold limit-lines-text' style={{ WebkitLineClamp: '2' }}>{publicationSelected?.userName ?? 'Cargando nombre...'}</span>
                                </Link>

                                <p>{(fechaToText(publicationSelected?.published_at) ?? 'Cargando fecha...') + ' ' + (publicationSelected?.location ?? 'Cargando ubicacion...')}</p>
                            </div>
                        </div>

                        {
                            publicationSelected.use_whatsapp ? (
                                <a href={`https://wa.me/${publicationSelected?.phoneNumber}?text=${encodeURIComponent("Hola! Me interesa esta publicación:\n" + API_URL + "view/publications/" + publicationSelected?.authCode)}`} target='_blank'>
                                    <WhatsAppIcon style={{ color: 'var(--color-whatsapp)', fontSize: '40px' }} />
                                </a>
                            ) : (
                                <WhatsAppIcon style={{ color: 'transparent', fontSize: '40px' }} />
                            )
                        }
                    </div>

                    <div style={{ paddingLeft: '6px', width: '100%' }}>
                        <LimitText lineLimit={[5, 7, 8]} class_container='cpp-1-description scroll-thin'>
                            {publicationSelected?.description}
                        </LimitText>
                    </div>

                    <div className='cpp-1-comments preview-desktop' style={{ marginLeft: '6px' }}>{/*content preview post title comments  (si, esta mal escrito pero lo hice lo mas corto posible)*/}
                        <CommentGlobe color={'var(--line-color)'} main_css={{ backgroundColor: 'transparent', height: '30px' }} />
                        <span>Comentarios</span>
                    </div>

                    <ul className='list-comments preview-desktop scroll-thin'>
                        {
                            listComments
                        }
                    </ul>
                </div>

                <div className='preview-desktop'>
                    <div className='cpp-1-comments' style={{ border: 'none' }}>{/*content preview post title comments  (si, esta mal escrito pero lo hice lo mas corto posible)*/}
                        <button type='button' className='default-buttons' style={{ height: 'min-content' }} onClick={() => setStateEmoticons((current_bool) => !current_bool)}>
                            <MoodIcon style={{ fontSize: '35px', color: '#6E6E6E' }} />
                        </button>

                        <div className='container-picker' style={{ display: stateEmoticons ? 'block' : 'none', bottom: '0px', top: 'inherit' }}>
                            <Picker
                                data={data_emoticons}
                                previewPosition="none"
                                locale="es"
                                onEmojiSelect={
                                    (e) => {
                                        setComment((current_text) => {
                                            const descriptionString = String(current_text ?? '');

                                            const chars = Array.from(descriptionString);
                                            chars.splice(positionCaret.current, 0, e.native);
                                            const newDescription = chars.join('');

                                            positionCaret.current = positionCaret.current + 1;

                                            return newDescription;
                                        });
                                    }
                                }
                            />
                        </div>

                        <ButtonLoader
                            state_progress={isLoading.new_comment}
                            colorProgress='var(--empresa-color)'
                            type='button' className='default-buttons action-button'
                            onClick={addComment}>
                            <SendIcon style={{ fontSize: '20px', color: 'var(--empresa-color)' }} />
                        </ButtonLoader>

                        <input
                            type="text"
                            value={comment}
                            onChange={(e) => setComment(e.target.value)}
                            onBlur={(e) => positionCaret.current = e.target.selectionStart}
                            placeholder='Escribe un comentario'
                            onKeyDown={(e) => e.keyCode == 13 && addComment()}
                            disabled={isLoading.new_comment}
                        />
                    </div>
                </div>
            </div>

            {
                lengthImgs > 0 && (
                    <div className='bp-2 bp-2-preview'>
                        {
                            publicationSelected.img_list.map((url, indexI) => (
                                <>
                                    <ImagenesGlobal className='default-img post-img-blur'
                                        style={{ position: 'absolute', zIndex: 0, opacity: listPosition == indexI ? 1 : 0, filter: 'blur(4px)' }}
                                        url={url} alt='Imagen de fondo'
                                        loadImageS={loadImageS}
                                    />

                                    <ImagenesGlobal className='default-img shadow-lvl6'
                                        style={{
                                            display: listPosition == indexI ? 'block' : 'none',
                                            zIndex: 1,
                                            opacity: listPosition == indexI ? 1 : 0,
                                            width: 'auto',
                                            height: 'auto',
                                            maxHeight: '90%',
                                            maxWidth: '92%',
                                            objectFit: 'contain',
                                        }}
                                        url={url} alt='Imagen de publicaciones'
                                        loadImageS={loadImageS}
                                    />
                                </>

                            ))
                        }

                        {lengthImgs > 1 && (
                            <>
                                <div style={{ top: '0%', height: '100%' }}>
                                    <button className='default-buttons' style={styleButtons} onClick={(event) => handleMakeover(event, false)}>
                                        <ArrowBack style={{ color: '#000', fontSize: '35px' }} />
                                    </button>

                                    <button className='default-buttons' style={styleButtons} onClick={(event) => handleMakeover(event, true)}>
                                        <ArrowNext style={{ color: '#000', fontSize: '35px' }} />
                                    </button>
                                </div>

                                <div style={{ justifyContent: 'center', bottom: '5%', gap: '10px', opacity: 1 }}>
                                    {[0, 1, 2].map((_, index) => (
                                        <span key={index} title='Indicador si hay mas de una imagen'></span>
                                    ))}
                                </div>
                            </>
                        )}

                    </div>
                )
            }

            <div className='cpp-1-comments preview-mobile'>{/*content preview post title comments  (si, esta mal escrito pero lo hice lo mas corto posible)*/}
                <CommentGlobe color={'var(--line-color)'} main_css={{ backgroundColor: 'transparent', height: '30px' }} />
                <span>Comentarios</span>
            </div>

            <ul className='list-comments preview-mobile scroll-thin' style={{ minHeight: '260px' }}>
                {
                    listComments
                }
            </ul >

            <div className='cpp-1-comments preview-mobile' style={{ border: 'none', marginTop: 'auto' }}>{/*content preview post title comments  (si, esta mal escrito pero lo hice lo mas corto posible)*/}
                <ProfileContent
                    profile_url={myProfile}
                    loadImageS={loadImageS}
                    className='shadow-lvl2'
                    style={{ height: '40px' }}
                />

                <ButtonLoader
                    state_progress={isLoading.new_comment}
                    colorProgress='var(--empresa-color)'
                    type='button' className='default-buttons action-button'
                    onClick={addComment}>
                    <SendIcon style={{ fontSize: '20px', color: 'var(--empresa-color)' }} />
                </ButtonLoader>

                <input
                    type="text"
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                    placeholder='Escribe un comentario'
                    onKeyDown={(e) => e.keyCode == 13 && addComment()}
                    disabled={isLoading.new_comment}
                />
            </div>
        </ModalForAll >
    )
}

export default PreviewPublication